import API_BASE from "../config";
import authHeader from "./auth-header";
import axios from "axios";

const API_URL = API_BASE + "/api/catalogs";

const getAll = () => axios.get(API_URL);

const get = (id) => axios.get(`${API_URL}/${id}`);

const create = (data) =>
  axios.post(API_URL, data, { headers: authHeader() });

const update = (id, data) =>
  axios.put(`${API_URL}/${id}`, data, { headers: authHeader() });

const remove = (id) =>
  axios.delete(`${API_URL}/${id}`, { headers: authHeader() });

const CatalogService = { getAll, get, create, update, remove };

export default CatalogService;
